export const handleSubmit = ({ createSource, history, currentCustomerId }) => values => {
  const updatedData = createSource({
    variables: {
      sourceInput: {
        ...values,
        customerId: undefined,
      },
      customerId: currentCustomerId,
    },
  });

  return updatedData.then(result => {
    const source = result.data ? result.data.createSource : null;
    if (source && source.id) {
      history.replace(`/source/details/${source.id}`);
    }
  });
};
